import styled from 'styled-components';
import { Point } from 'dragonmouse-shared/geometry';

// Re-export all shared styles from parent
export * from '../styles';

// Import ThumbnailScroller from shared styles for extending
import { ThumbnailScroller } from '../styles';

// Scene-specific styles

export const Thumbnails = styled(ThumbnailScroller)`
	margin-bottom: 12px;
`;

export const Frames = styled(ThumbnailScroller)`
	margin-top: 12px;
	margin-bottom: 16px;
	border-radius: 8px;
	cursor: default;
	user-select: none;
`;

interface SelectionButtonProps {
	corner: Point;
	selected: boolean;
}

export const SelectionButton = styled.div<SelectionButtonProps>`
	//layout
	position: fixed;
	left: ${(props) => props.corner.x}px;
	top: ${(props) => props.corner.y}px;
	z-index: 1000;
	border: 1px solid ${({ theme }) => theme.gray[600]};
	background-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[0])};
	width: 28px;
	height: 28px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[200])};
	}
`;
